import * as React from "react";
import { mergeClassNames } from "./class-names";

export const Card = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div">
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-slot="card"
    className={mergeClassNames(
      "min-w-0 rounded-lg border border-border-subtle bg-surface text-primary shadow-[var(--elevation-1)]",
      className,
    )}
    {...props}
  />
));
Card.displayName = "Card";

export const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div">
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-slot="card-header"
    className={mergeClassNames("grid min-w-0 gap-1.5 p-5", className)}
    {...props}
  />
));
CardHeader.displayName = "CardHeader";

export interface CardTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  readonly as?: "h2" | "h3" | "h4";
}

export const CardTitle = React.forwardRef<HTMLHeadingElement, CardTitleProps>(
  ({ as: Heading = "h2", className, ...props }, ref) => (
    <Heading
      ref={ref}
      data-slot="card-title"
      className={mergeClassNames(
        "text-heading-medium min-w-0 break-words [overflow-wrap:anywhere]",
        className,
      )}
      {...props}
    />
  ),
);
CardTitle.displayName = "CardTitle";

export const CardDescription = React.forwardRef<
  HTMLParagraphElement,
  React.ComponentPropsWithoutRef<"p">
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    data-slot="card-description"
    className={mergeClassNames(
      "text-body min-w-0 break-words text-secondary [overflow-wrap:anywhere]",
      className,
    )}
    {...props}
  />
));
CardDescription.displayName = "CardDescription";

export const CardContent = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div">
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-slot="card-content"
    className={mergeClassNames("min-w-0 px-5 pb-5", className)}
    {...props}
  />
));
CardContent.displayName = "CardContent";
